import { Component, forwardRef, KeyValueDiffers, ChangeDetectorRef, ElementRef, OnInit, Input } from '@angular/core';

import { BlockComponent } from '../../../../Common/PageBuilder/components/Block/block.component';
import { AbstractPageBuilderService } from '../../../../Common/PageBuilder/services/abstract-page-builder.service';
import { ClickOutsideService } from '../../../../Common/PageBuilder/services/click-outside.service';
import { BriefingImageDisplayElementModel } from '../../../../Common/PageBuilder/models/briefing-image-display-element.model';
import { BlockDisplayTypeEnum } from '../../../../Common/PageBuilder/enums/block-display-type.enum';
import { ImageSourceEnum } from '../../../../Common/PageBuilder/enums/image-source.enum';

@Component({
    selector: 'agpr-briefing-image-block',
    templateUrl: './briefing-image-block.component.html',
    styleUrls: ['./briefing-image-block.component.scss'],
    providers: [
        {
            provide: BlockComponent,
            useExisting: forwardRef(() => BriefingImageBlockComponent)
        }
    ],
    standalone: false
})
export class BriefingImageBlockComponent extends BlockComponent implements OnInit{

    public showAutomatePlaceholder: boolean = false;

    constructor(
        public differs: KeyValueDiffers,
        public pageBuilderService: AbstractPageBuilderService,
        protected changeDetectorRef: ChangeDetectorRef,
        public clickOutsideService: ClickOutsideService,
        public el: ElementRef
    ) {
        super(differs, pageBuilderService, changeDetectorRef, clickOutsideService, el);
    }

    ngOnInit(): void {
        super.ngOnInit();
    }

    updateTwigData() {
        this.showAutomatePlaceholder = false;
        const data: any = {};
        const imageDisplayElement = this.block.displayElement as BriefingImageDisplayElementModel;

        this.twigData = Object.assign(data, imageDisplayElement, imageDisplayElement.imageProperties);

        if (imageDisplayElement?.images?.[0]) {
            if (imageDisplayElement.images[0].url) {
                this.twigData.url = imageDisplayElement.images[0].url;
            }
            if (imageDisplayElement.images[0].width) {
                this.twigData.width = imageDisplayElement.images[0].width;
            }
            if (imageDisplayElement.images[0].altText) {
                this.twigData.altText = imageDisplayElement.images[0].altText;
            }

            if (imageDisplayElement.images[0].imageSource === ImageSourceEnum.AUTOMATE && imageDisplayElement.displayType !== BlockDisplayTypeEnum.ONLINE) {
                this.showAutomatePlaceholder = true;
            }
        }
    }
}
